/**
 * Wheelify Spin Wheel Email Pop Integration
 * Handles redirect to product page when copy-button is clicked
 * Prevents multiple additions of free gift products
 */

(function() {
  'use strict';

  // Configuration: Map discount codes to product URLs
  // Wheelify Gift Product Mapping
  const WHEELIFY_PRODUCT_MAP = {
    // Gift 1 → The HWDS Collection Christmas stocking
    'HWDSXMASSTOCKING': '/products/the-hwds-collection-christmas-stocking',
    
    // Gift 2 → Sap Sak by Sak Sak bags
    'SAPSAK': '/products/sap-sak-by-sak-sak-bags',
    
    // Gift 3 → Babylonstoren Pantry Surprise
    'PANTRYSURPRISE!': '/products/babylonstoren-pantry-surprise',
    
    // Note: These handles will be overridden by wheelify-config.liquid if configured there
  };

  /**
   * Get discount code from Wheelify popup
   * This function tries multiple methods to extract the discount code
   */
  function getDiscountCode(button) {
    console.log('Wheelify Integration: getDiscountCode called for button:', button);
    
    // Method 1: PRIORITY - Check for input fields with the coupon code (most reliable)
    const popup = button.closest('[class*="wheelify"], [class*="popup"], [id*="wheelify"], [class*="modal"], [class*="reveal"]');
    if (popup) {
      // Look for input fields with name="coupon" or similar
      const couponInput = popup.querySelector('input[name="coupon"], input[name="code"], input[type="text"][readonly], input[class*="coupon"], input[class*="code"]');
      if (couponInput && couponInput.value) {
        const code = couponInput.value.trim();
        console.log('Wheelify Integration: Found code in input field:', code);
        if (code && code.length >= 3) {
          // Check if this matches any configured code (case-insensitive)
          for (const configuredCode of Object.keys(WHEELIFY_PRODUCT_MAP)) {
            if (code.toLowerCase() === configuredCode.toLowerCase()) {
              console.log('Wheelify Integration: Input code matches configured code:', configuredCode);
              return configuredCode;
            }
          }
          // If no match, return the code as-is
          return code;
        }
      }
    }

    // Method 2: Check if code is in a data attribute on the button or nearby elements
    const codeFromData = button.dataset.code || 
                         button.closest('[data-code]')?.dataset.code ||
                         button.closest('[data-coupon]')?.dataset.coupon;
    if (codeFromData) {
      console.log('Wheelify Integration: Found code from data attribute:', codeFromData);
      return codeFromData;
    }

    // Method 3: Check if code is in a data attribute in the popup
    if (popup) {
      const codeElement = popup.querySelector('[class*="code"], [class*="coupon"], [data-code], [data-coupon]');
      if (codeElement) {
        const code = codeElement.textContent?.trim() || 
                     codeElement.dataset?.code || 
                     codeElement.dataset?.coupon ||
                     codeElement.innerText?.trim();
        if (code && code.length >= 3) {
          console.log('Wheelify Integration: Found code in element:', code);
          return code;
        }
      }
    }

    // Method 4: Look for configured codes in popup text (prioritize configured codes)
    if (popup) {
      const popupText = popup.textContent || popup.innerText || '';
      console.log('Wheelify Integration: Popup text (first 500 chars):', popupText.substring(0, 500));
      
      // Check each configured code to see if it appears in the popup (case-insensitive)
      for (const configuredCode of Object.keys(WHEELIFY_PRODUCT_MAP)) {
        const codeLower = configuredCode.toLowerCase();
        const textLower = popupText.toLowerCase();
        
        // Check if the configured code appears in the popup text
        if (textLower.includes(codeLower)) {
          console.log('Wheelify Integration: Found configured code in popup text:', configuredCode);
          return configuredCode;
        }
      }
    }

    // Method 5: Look for code in nearby text (check siblings and parent)
    // This handles codes with spaces, mixed case, etc.
    let currentElement = button.parentElement;
    for (let i = 0; i < 5 && currentElement; i++) {
      const text = currentElement.textContent || '';
      
      // FIRST: Check if any configured codes appear in this element
      for (const configuredCode of Object.keys(WHEELIFY_PRODUCT_MAP)) {
        if (text.toLowerCase().includes(configuredCode.toLowerCase())) {
          console.log('Wheelify Integration: Found configured code in nearby text:', configuredCode);
          return configuredCode;
        }
      }
      
      // SECOND: Look for codes with spaces and mixed case (like "test product")
      // Try to find text that looks like a discount code displayed in the popup
      const lines = text.split('\n').map(line => line.trim()).filter(line => line.length > 0);
      for (const line of lines) {
        // Skip lines that are clearly UI elements
        if (line.match(/^(copy|click|button|svg|path|off|get|use|save|free)$/i) || line.length < 3) {
          continue;
        }
        // Check if this line matches any code in our mapping (case-insensitive)
        const normalizedLine = line.trim();
        if (normalizedLine.length >= 3 && normalizedLine.length <= 50) {
          // Check against mapping (try exact match, lowercase, and trimmed versions)
          if (WHEELIFY_PRODUCT_MAP[normalizedLine] || 
              WHEELIFY_PRODUCT_MAP[normalizedLine.toLowerCase()] ||
              Object.keys(WHEELIFY_PRODUCT_MAP).some(key => 
                key.toLowerCase() === normalizedLine.toLowerCase()
              )) {
            // Return the key from the map (to preserve exact casing)
            const matchingKey = Object.keys(WHEELIFY_PRODUCT_MAP).find(key => 
              key.toLowerCase() === normalizedLine.toLowerCase()
            );
            console.log('Wheelify Integration: Found matching code in text:', matchingKey || normalizedLine);
            return matchingKey || normalizedLine;
          }
        }
      }
      
      // THIRD: Try to find uppercase alphanumeric codes (but filter out false positives)
      const uppercaseCodeMatch = text.match(/\b[A-Z0-9]{4,20}\b/g);
      if (uppercaseCodeMatch) {
        for (const code of uppercaseCodeMatch) {
          // Filter out common false positives
          if (!['COPY', 'CLICK', 'BUTTON', 'SVG', 'PATH', 'OFF', 'GET', 'USE', 'SAVE', 'FREE'].includes(code)) {
            console.log('Wheelify Integration: Found uppercase code:', code);
            return code;
          }
        }
      }
      
      currentElement = currentElement.parentElement;
    }

    // Method 4: Check localStorage (Wheelify might store it)
    const storedCode = localStorage.getItem('wheelify_discount_code');
    if (storedCode) return storedCode;

    // Method 5: Try to get from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const codeFromUrl = urlParams.get('code') || urlParams.get('coupon');
    if (codeFromUrl) return codeFromUrl;

    return null;
  }

  /**
   * Get product URL from discount code
   */
  function getProductUrl(discountCode, button) {
    if (!discountCode) return null;
    
    // Method 1: Check data attribute on the button (easiest method)
    if (button) {
      if (button.dataset.productUrl) {
        return button.dataset.productUrl;
      }
      if (button.dataset.productHandle) {
        return '/products/' + button.dataset.productHandle;
      }
      
      const parentWithUrl = button.closest('[data-product-url]');
      if (parentWithUrl?.dataset.productUrl) {
        return parentWithUrl.dataset.productUrl;
      }
      
      const parentWithHandle = button.closest('[data-product-handle]');
      if (parentWithHandle?.dataset.productHandle) {
        return '/products/' + parentWithHandle.dataset.productHandle;
      }
    }

    // Method 2: Check the mapping configuration (case-insensitive)
    if (WHEELIFY_PRODUCT_MAP[discountCode]) {
      return WHEELIFY_PRODUCT_MAP[discountCode];
    }
    // Try case-insensitive match
    const matchingKey = Object.keys(WHEELIFY_PRODUCT_MAP).find(key => 
      key.toLowerCase() === discountCode.toLowerCase()
    );
    if (matchingKey) {
      return WHEELIFY_PRODUCT_MAP[matchingKey];
    }

    // Method 3: Try to find product URL from Wheelify popup data attributes
    if (button) {
      const popup = button.closest('[class*="wheelify"], [class*="popup"], [id*="wheelify"]');
      if (popup) {
        if (popup.dataset.productUrl) {
          return popup.dataset.productUrl;
        }
        if (popup.dataset.productHandle) {
          return '/products/' + popup.dataset.productHandle;
        }
      }
    }

    return null;
  }

  /**
   * Check if product is already in cart
   */
  async function isProductInCart(productHandle) {
    try {
      const response = await fetch(theme.routes.cart + '?t=' + Date.now(), {
        credentials: 'same-origin',
        method: 'GET'
      });
      
      if (!response.ok) return false;
      
      const cart = await response.json();
      if (!cart.items || cart.items.length === 0) return false;

      // Check if any cart item matches the product handle
      return cart.items.some(item => {
        const itemHandle = item.product_handle || item.handle;
        return itemHandle === productHandle;
      });
    } catch (error) {
      console.error('Error checking cart:', error);
      return false;
    }
  }

  /**
   * Copy text to clipboard
   */
  async function copyToClipboard(text) {
    try {
      // Try modern clipboard API first
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        console.log('Wheelify Integration: Code copied to clipboard via Clipboard API');
        return true;
      }
      
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        if (successful) {
          console.log('Wheelify Integration: Code copied to clipboard via execCommand');
          return true;
        }
      } catch (err) {
        document.body.removeChild(textArea);
        console.error('Wheelify Integration: Failed to copy via execCommand:', err);
        return false;
      }
    } catch (error) {
      console.error('Wheelify Integration: Failed to copy to clipboard:', error);
      return false;
    }
    return false;
  }

  /**
   * Handle copy button click
   */
  function handleCopyButtonClick(event) {
    console.log('Wheelify Integration: handleCopyButtonClick called', event);
    
    // Get the button - try multiple methods since event delegation can be tricky
    let button = null;
    
    // Method 1: If button was passed directly
    if (event.button) {
      button = event.button;
    }
    // Method 2: Try to find from target
    else if (event.target) {
      button = event.target.closest('.copy-button') || 
               event.target.closest('[class*="copy-button"]') ||
               (event.target.classList && event.target.classList.contains('copy-button') ? event.target : null);
    }
    // Method 3: Try currentTarget (usually document in delegation)
    else if (event.currentTarget && event.currentTarget.classList && event.currentTarget.classList.contains('copy-button')) {
      button = event.currentTarget;
    }
    
    if (!button) {
      console.error('Wheelify Integration: No button found in event', {
        target: event.target,
        currentTarget: event.currentTarget,
        targetClasses: event.target?.className,
        targetTagName: event.target?.tagName
      });
      return;
    }
    
    console.log('Wheelify Integration: Button element:', button);
    console.log('Wheelify Integration: Button parent:', button.parentElement);
    
    // Get discount code
    const discountCode = getDiscountCode(button);
    console.log('Wheelify Integration: Extracted discount code:', discountCode);
    
    if (!discountCode) {
      console.warn('Wheelify Integration: Could not extract discount code. Button context:', {
        buttonText: button.textContent,
        parentText: button.parentElement?.textContent,
        nearbyText: button.closest('div')?.textContent?.substring(0, 200)
      });
      // Don't prevent default if we can't get the code - let Wheelify handle it
      return;
    }

    // Copy the discount code to clipboard FIRST
    copyToClipboard(discountCode).then(copied => {
      if (copied) {
        console.log('Wheelify Integration: Discount code copied to clipboard:', discountCode);
        
        // Show a brief visual feedback (optional)
        const originalText = button.textContent;
        if (button.querySelector('span')) {
          button.querySelector('span').textContent = 'Copied!';
        } else {
          button.textContent = 'Copied!';
        }
        setTimeout(() => {
          if (button.querySelector('span')) {
            button.querySelector('span').textContent = originalText;
          } else {
            button.textContent = originalText;
          }
        }, 1000);
      } else {
        console.warn('Wheelify Integration: Failed to copy code, but continuing with redirect');
      }
    });

    // Store discount code in localStorage for later use
    localStorage.setItem('wheelify_discount_code', discountCode);
    localStorage.setItem('wheelify_timestamp', Date.now().toString());

    // Get product URL
    const productUrl = getProductUrl(discountCode, button);
    console.log('Wheelify Integration: Product URL for code "' + discountCode + '":', productUrl);
    
    if (!productUrl) {
      console.warn('Wheelify Integration: No product URL mapped for discount code:', discountCode);
      console.warn('Wheelify Integration: Available mappings:', Object.keys(WHEELIFY_PRODUCT_MAP));
      // Code is already copied, just don't redirect
      return;
    }

    // Extract product handle from URL
    const urlMatch = productUrl.match(/\/products\/([^\/\?]+)/);
    if (!urlMatch) {
      console.warn('Wheelify: Invalid product URL format:', productUrl);
      return;
    }

    const productHandle = urlMatch[1];

    // Small delay to ensure copy completes, then redirect
    setTimeout(() => {
      // Check if product is already in cart
      isProductInCart(productHandle).then(inCart => {
        if (inCart) {
          // Product already in cart, just redirect to product page with message
          const redirectUrl = productUrl + '?wheelify_gift=true&already_in_cart=true&code=' + encodeURIComponent(discountCode);
          window.location.href = redirectUrl;
        } else {
          // Product not in cart, redirect to product page
          const redirectUrl = productUrl + '?wheelify_gift=true&code=' + encodeURIComponent(discountCode);
          window.location.href = redirectUrl;
        }
      }).catch(error => {
        console.error('Wheelify: Error checking cart:', error);
        // Redirect anyway if check fails
        const redirectUrl = productUrl + '?wheelify_gift=true&code=' + encodeURIComponent(discountCode);
        window.location.href = redirectUrl;
      });
    }, 300); // 300ms delay to ensure clipboard copy completes
  }

  /**
   * Initialize Wheelify integration
   */
  function initWheelifyIntegration() {
    if (window.wheelifyIntegrationInitialized) {
      console.log('Wheelify Integration: Already initialized, skipping...');
      return;
    }
    window.wheelifyIntegrationInitialized = true;
    console.log('Wheelify Integration: Initializing...');
    
    // Use event delegation with capture phase to intercept before Wheelify handles it
    document.addEventListener('click', function(event) {
      // Try multiple selectors in case Wheelify uses different classes
      const copyButton = event.target.closest('.copy-button') ||
                        event.target.closest('[class*="copy"]') ||
                        (event.target.textContent && event.target.textContent.toLowerCase().includes('copy') && event.target.closest('button')) ||
                        null;
      
      if (copyButton) {
        console.log('Wheelify Integration: Copy button clicked!', copyButton);
        console.log('Wheelify Integration: Button classes:', copyButton.className);
        console.log('Wheelify Integration: Button text:', copyButton.textContent);
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        // Create a new event-like object with the button attached
        const customEvent = {
          ...event,
          button: copyButton,
          target: event.target,
          currentTarget: copyButton
        };
        handleCopyButtonClick(customEvent);
      }
    }, true); // Use capture phase to intercept early

    // Also add direct listener to any existing buttons
    const existingButtons = document.querySelectorAll('.copy-button, [class*="copy-button"]');
    console.log('Wheelify Integration: Found', existingButtons.length, 'existing copy buttons');
    existingButtons.forEach(button => {
      console.log('Wheelify Integration: Found existing copy button', button, 'Classes:', button.className);
      button.addEventListener('click', function(event) {
        console.log('Wheelify Integration: Direct button click handler triggered');
        event.preventDefault();
        event.stopPropagation();
        const customEvent = {
          ...event,
          button: button,
          target: event.target,
          currentTarget: button
        };
        handleCopyButtonClick(customEvent);
      }, true);
    });

    // Watch for dynamically added buttons
    const observer = new MutationObserver(function(mutations) {
      const copyButtons = document.querySelectorAll('.copy-button:not([data-wheelify-handled]), [class*="copy-button"]:not([data-wheelify-handled])');
      if (copyButtons.length > 0) {
        console.log('Wheelify Integration: Detected', copyButtons.length, 'new copy button(s)');
      }
      copyButtons.forEach(button => {
        console.log('Wheelify Integration: New copy button detected', button, 'Classes:', button.className);
        button.setAttribute('data-wheelify-handled', 'true');
        button.addEventListener('click', function(event) {
          console.log('Wheelify Integration: Dynamic button click handler triggered');
          event.preventDefault();
          event.stopPropagation();
          const customEvent = {
            ...event,
            button: button,
            target: event.target,
            currentTarget: button
          };
          handleCopyButtonClick(customEvent);
        }, true);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    console.log('Wheelify Integration: Initialized. Product map:', WHEELIFY_PRODUCT_MAP);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Wait a bit for Wheelify to load
      setTimeout(initWheelifyIntegration, 500);
    });
  } else {
    // Wait a bit for Wheelify to load
    setTimeout(initWheelifyIntegration, 500);
  }
  
  // Also try initializing after a longer delay in case Wheelify loads very late
  setTimeout(function() {
    if (!window.wheelifyIntegrationInitialized) {
      console.log('Wheelify Integration: Re-initializing after delay...');
      initWheelifyIntegration();
    }
  }, 2000);

  // Export for manual configuration
  window.WheelifyIntegration = {
    setProductMap: function(map) {
      Object.assign(WHEELIFY_PRODUCT_MAP, map);
    },
    addProductMapping: function(code, url) {
      WHEELIFY_PRODUCT_MAP[code] = url;
    }
  };

})();

